'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { usePreferencesStore } from '@/shared/ui/model';

export function PreferencesProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { theme, setTheme } = useTheme();
  const preferencesStore = usePreferencesStore();

  // Sync preferences store with next-themes
  useEffect(() => {
    const unsubscribe = usePreferencesStore.subscribe(
      (state) => state.theme.mode,
      (mode) => {
        setTheme(mode);
      }
    );

    return unsubscribe;
  }, [setTheme]);

  // Sync next-themes with preferences store on mount
  useEffect(() => {
    if (theme && theme !== preferencesStore.theme.mode) {
      preferencesStore.setThemeMode(theme as 'light' | 'dark' | 'system');
    }
  }, [theme, preferencesStore]);

  // Apply initial theme settings
  useEffect(() => {
    preferencesStore.applyTheme();
  }, [preferencesStore]);

  return <>{children}</>;
}
